import Announcement from '@admin/components/announcement'
import ModalPanel from '@admin/components/modal_panel'
import Infinite from '@admin/components/infinite'
import React from 'react'

class Announcements extends React.Component {

  static propTypes = {}


  render() {
    return (
      <ModalPanel { ...this._getPanel() }>
        <div className="maha-announcements">
          <Infinite { ...this._getInfinite() } />
        </div>
      </ModalPanel>
    )
  }

  _getPanel() {
    return {
      title: 'Announcements'
    }
  }
  _getInfinite() {
    return {
      endpoint: '/api/admin/announcements',
      layout: ({ records }) => records.map((announcement, index) => (
        <Announcement is_new={ announcement.is_new } announcement={ announcement.config } key={`announcement-${index}`} />
      )),
      empty: {
        svg: 'megaphone',
        title: 't(No Announcements)',
        text: 't(There are no new announcements)'
      }
    }
  }

}

export default Announcements
